import React from "react";
import {
    Datagrid,
    DateField,
    List,
    SimpleShowLayout,
    TextField,
    required,
    TextInput,
    ImageInput,
    ImageField
} from "react-admin";
import CreateView from "../../components/CreateView";
import EditView from "../../components/EditView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";

export const PlanFeaturesList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
        <TextField source="title"/>
        <TextField source="description"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const PlanFeaturesCreate = (props) => (
    <CreateView {...props} perPage={10}>
        <TextInput source="title" validate={required()}/>
        <Emoji label="توضیحات" source="description" validate={required()}/>
        <ImageInput source="pictures"  label="تصویر مربوطه" accept="image/*">
            <ImageField source="src" title="title"/>
        </ImageInput>
    </CreateView>
);


export const PlanFeaturesEdit = (props) => {
    return (
    <EditView {...props}>
        <TextInput source="title" validate={required()}/>
        <Emoji label="توضیحات" source="description" validate={required()}/>
        <ImageInput source="pictures"  label="تصویر مربوطه" accept="image/*">
            <ImageField source="src" title="title"/>
        </ImageInput>
        <TextInput source="icon" validate={required()}/>
    </EditView>
    );
}

export const PlanFeaturesShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="objectId"/>
        <TextField source="title"/>
        <TextField source="description"/>
        <ImageField source="icon"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);
